import { SHStack, SHTypography } from "@components/design-systems";
import { RootState } from "@redux/store";
import { memo } from "react";
import { useSelector } from "react-redux";

export const SummaryPlatformsIncluded = memo(() => {
  const storedSelectedProducts = useSelector(
    (state: RootState) =>
      state.platformAnalysis?.platformAnalysis?.summary?.selectedProducts,
  );

  return (
    <SHStack spacing={"5px"}>
      <SHTypography variant="subtitle2">
        Platforms included in the analysis
      </SHTypography>
      <SHTypography variant="body2">
        {storedSelectedProducts?.map((product) => product.name).join(", ")}
      </SHTypography>
    </SHStack>
  );
});
